module.exports = "@media screen and (min-width: 1170px) {\n  .hoc {\n    min-width: 1100px; } }\n\n.post-title {\n  margin-bottom: 0;\n  font-family: inherit;\n  font-size: 13px;\n  line-height: 1.6; }\n\n.text-muted {\n  color: #777;\n  font-size: 11px; }\n\n.color-grey {\n  color: #777; }\n\n.content-text {\n  color: #303030;\n  font-size: 14px;\n  margin: 9px 0 14px 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-main/components/search-pages-news/search-pages-news.component.scss
// module id = ./src/app/modules/common-main/components/search-pages-news/search-pages-news.component.scss
// module chunks = main